module.exports = __webpack_public_path__ + "static/img/1.12fdaf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/1.png
// module id = Jb4h
// module chunks = 0